import { List } from 'antd';
import styled from 'styled-components';

export const StyledList = styled(List)`
  width: 360px;

  .ant-collapse-header {
    position: relative;
    height: 36px !important;
    border-top: none !important;
    &:hover {
      background: var(--blue-20) !important;
    }
    .ant-collapse-arrow {
      top: 0;
    }
  }

  .ant-collapse-item-active {
    padding-bottom: 0 !important;
  }

  .ant-list-header {
    font-weight: var(--font-weight-bold);
    padding: var(--spacing-03) var(--spacing-05);
  }

  .ant-list-item {
    padding: var(--spacing-03) var(--spacing-05);
    cursor: pointer;

    &:hover {
      background: var(--blue-20);

      span {
        background: #fff;
      }
    }

    span {
      background: var(--coolest-gray-10);
      width: 24px;
      height: 24px;
      margin-left: var(--spacing-02);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: var(--spacing-01);
      box-shadow: var(--shadow-01);
    }
  }

  .ant-list-item-meta-title {
    margin: 0;
  }

  .ant-list-item-meta-description {
    font-size: var(--font-size-sm);
    color: var(--text-02);
    line-height: var(--line-height-code-01);
  }
`;
